import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getLocale } from '../../../../configuration';
import type { RootState } from '../../../../configuration/setup/store';
import { getTermsAndConditionsUrl } from '../../config/productConfig';
import { useDialogCloseTrackingLabel } from '../utils/useDialogCloseTrackingLabel';

interface Props {
    locale: string;
    serviceSku: string;
    level?: string;
    children: React.ReactNode;
}

const TermsAndConditions = ({ serviceSku, level, children, locale }: Props) => {
    const [show, setShow] = useState(false);
    const intl = useIntl();
    const dialogTitleId = 'marketplace.myServices.termsAndConditions.dialogTitle';
    const iframeTitle = intl.formatMessage({ id: dialogTitleId });
    useDialogCloseTrackingLabel(show, dialogTitleId);

    return (
        <>
            <Dialog
                show={show}
                title={<FormattedMessage id={dialogTitleId} />}
                body={
                    <iframe
                        className='position-absolute top-0 left-0 width-100pct height-100pct'
                        src={getTermsAndConditionsUrl(locale, serviceSku, level)}
                        title={iframeTitle}
                    />
                }
                onClose={() => setShow(false)}
                footer={null}
                showCloseButton={true}
                bsSize={Dialog.SIZE_FULL_SCREEN}
            />
            <span
                onClick={event => {
                    event.preventDefault();
                    setShow(true);
                }}
            >
                {children}
            </span>
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    locale: getLocale(state),
});

export const TermsAndConditionsContainer = connect(mapStateToProps)(TermsAndConditions);
